import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { actions, Control, Errors, Form } from 'forms/rrf';
import Number from '../../../../common/form/spinner';
import RequiredInput from '../../../../common/form/elements/required-input';
import RequiredSelect from '../../../../common/form/elements/required-select';
import BsCheckbox from '../../../../common/form/elements/bs-checkbox';
import { getBrands } from '../../../../../actions/brands';
import ImageUpload from '../../../../common/form/elements/image-upload';
import { getProduct, getGroups, saveProduct, updateProduct } from '../../../../../actions/products';
import PageTitle from '../../../../common/page-title/index';
import BackLink from '../../../../common/back-link/index';
import ArrowButton from '../../../../common/button-arrow';
import TextInput from '../../../../common/form/elements/text-input';
import t from '../../../../../data/translations';
import MultiSelect from '../../../../common/form/multi-select';

const statusOptions = [
  { value: 'ACTIVE', label: 'ACTIVE' },
  { value: 'INACTIVE', label: 'INACTIVE' }
];

const stockStatusOptions = [
  { value: 'In Stock', label: 'In Stock' },
  { value: 'Out of Stock', label: 'Out of Stock' }
];

class NewProduct extends Component {
  handleSubmit = (payLoad) => {
    const { dispatch } = this.props;

    if (this.isEdit()) {
      dispatch(actions.submitFields('deep.admin_product_save', updateProduct(this.id, payLoad, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.admin_product_save', saveProduct(payLoad, dispatch)));
    }
  };

  constructor(props) {
    super(props);

    this.id = this.props.match.params.id;
  }

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;

    dispatch(getBrands());
    dispatch(getGroups());

    if (this.isEdit()) {
      dispatch(getProduct(this.id));
    } else {
      this.props.dispatch(actions.reset('deep.admin_product_save'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_product_save'));
  }

  isEdit() {
    return this.id && parseInt(this.id);
  }

  isProductLoading() {
    return this.isEdit() && this.props.productLoading;
  }

  handleSubmit = (payLoad) => {
    const { dispatch } = this.props;

    if (this.isEdit()) {
      dispatch(actions.submitFields('deep.admin_product_save', updateProduct(this.id, payLoad, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.admin_product_save', saveProduct(payLoad, dispatch)));
    }
  };

  createGroupList = (groups) => {
    const grps = groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

    return grps;
  };

  handleChange(event, model) {
    const {dispatch} = this.props;

    dispatch(actions.setErrors(model, {
      required: event.target.checked
    }));

    if (event.target.checked) {
      dispatch(actions.change(model, []));
    }
  }

  render() {
    const { formData } = this.props;

    const brands = [];
    const categories = [];

    this.props.brands.forEach((category) => {
      categories.push(category);

      if (parseInt(this.props.category_id) !== parseInt(category.id)) {
        return;
      }

      category.attributes.brands.forEach((brand) => {
        if (!brands.find(existingBrand => existingBrand.id === brand.id)) {
          brands.push(brand);
        }
      });
    });

    if (this.isProductLoading()) {
      return (
        <div className="container-fluid">
          <PageTitle>
            {this.isEdit() ? 'Edit Product' : 'Add Product'}
          </PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      );
    }

    let image = '';

    if (formData.links && formData.links.photo) {
      image = formData.links.photo;
    }

    let porImage = '';

    if (formData.links && formData.links['por-image']) {
      porImage = formData.links['por-image'];
    }

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/products"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              {this.isEdit() ? 'Edit Product' : 'Add Product'}
            </PageTitle>
          </Col>
        </Row>
        <Form model='deep.admin_product_save' onSubmit={data => this.handleSubmit(data)}>
          <Row>
            <Col md={12}>
              <Errors className="errors" model="deep.admin_product_save"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId='name'
                label="Name"
                model='.name'
                placeholder="Name"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId='variant'
                label="Variant"
                model='.variant'
                placeholder="Variant"
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <RequiredSelect
                controlId="productStatus"
                label="Status"
                model=".status"
                values={statusOptions}
              />

            </Col>
            <Col md={6}>
              <RequiredSelect
                controlId="stockStatus"
                label="Stock Status"
                model=".stock_status"
                values={stockStatusOptions}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <Control.checkbox component={BsCheckbox} model="deep.admin_product_save.special_new">
                New
              </Control.checkbox>

              <Errors
                className="errors"
                model="deep.admin_product_save.special_new"
                show={{touched: true}}
              />
            </Col>
            <Col sm={4}>
              <Control.checkbox component={BsCheckbox} model="deep.admin_product_save.special_featured">
                Featured
              </Control.checkbox>

              <Errors
                className="errors"
                model="deep.admin_product_save.special_featured"
                show={{touched: true}}
              />
            </Col>
            <Col sm={4}>
              <Control.checkbox
                model="deep.admin_product_save.special_reward"
                onClick={event => this.handleChange(event, 'deep.admin_product_save.group_ids')}
                component={BsCheckbox}
              >
                Reward
              </Control.checkbox>

              <Errors
                className="errors"
                model="deep.admin_product_save.special_reward"
                show={{touched: true}}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Control.checkbox component={BsCheckbox} model="deep.admin_product_save.exclude_from_marketing">
                Exclude from
                marketing
              </Control.checkbox>

              <Errors
                className="errors"
                model="deep.admin_product_save.exclude_from_marketing"
                show={{touched: true}}
              />
            </Col>
          </Row>
          <div>
            <Row>
              <Col md={12}>
                <MultiSelect
                  model='deep.admin_product_save.products_exceptions'
                  data={this.props.exceptionPostcodes || []}
                  label="Exceptions (postcode)"
                  value={formData.product_exceptions}
                  controlId="exceptions"
                  withAllOption
                />
              </Col>
            </Row>
          </div>
          { formData.special_reward === true && (
            <div>
              <Row>
                <Col md={12}>
                  <MultiSelect
                    model='deep.admin_product_save.group_ids'
                    data={this.createGroupList(this.props.groups) || []}
                    label="Eligible Groups"
                    value={formData.group_ids}
                    controlId="groups"
                  />
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <Col md={12}>
              <FormLabel>
                Image*
              </FormLabel>
              <ImageUpload
                model="deep.admin_product_save.photo"
                onImageLoaded={this.onImageLoaded}
                required
                sizeLimit={1024 * 1024}
                source={image}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormLabel>
                POR Image
              </FormLabel>
              <ImageUpload
                model="deep.admin_product_save.por_image"
                onImageLoaded={this.onImageLoaded}
                sizeLimit={1024 * 1024}
                source={porImage}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TextInput
                controlId='hyperlink'
                label="Hyperlink"
                model='.hyperlink'
                placeholder="Hyperlink"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId='sku'
                label="Sku"
                model='.sku'
                placeholder="Sku"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TextInput
                controlId="northernIrelandSKU"
                label="Northern Ireland SKU"
                model=".northern_ireland_sku"
                placeholder="Northern Ireland SKU"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId="product_eans"
                label="EAN(s) - please enter multiple values as comma separated e.g. 123456,1234567,12345678"
                model=".product_eans"
                placeholder="EAN(s)"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredSelect
                controlId="category"
                label="Category"
                labelAttr="attributes.name"
                model=".category_id"
                valueAttr="id"
                values={categories}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredSelect
                controlId="brand"
                label="Brand"
                labelAttr="name"
                model=".brand_id"
                valueAttr="id"
                values={brands}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId="rsp"
                label={t('rsp.withCurrency')}
                model=".rsp"
                placeholder="e.g 9.99"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                controlId="outer_price"
                label={`Outer Price (${t('currency')})`}
                model=".outer_price"
                placeholder="e.g 9.99"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="units_per_outer">
                <FormLabel>
                  Units per outer*
                </FormLabel>
                <Errors
                  className="errors"
                  model="deep.admin_product_save.units_per_outer"
                />
                <br />
                <Number
                  model="deep.admin_product_save.units_per_outer"
                  min={1}
                  value={parseInt(formData.units_per_outer) || 0}
                  required
                />

              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="order_limit_outers">
                <FormLabel>
                  Order limit (outers)*
                </FormLabel>
                <Errors
                  className="errors"
                  model="deep.admin_product_save.max_per_order"
                  show={{touched: true}}
                />
                <br/>
                <Number
                  model="deep.admin_product_save.max_per_order"
                  min={0}
                  value={parseInt(formData.max_per_order) || 0}
                  required
                />

              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="tar">
                <FormLabel>
                  Tar (mg)
                </FormLabel>
                <Errors
                  className="errors"
                  model="deep.admin_product_save.tar"
                  show={{touched: true}}
                />
                <Control.text
                  component={FormControl}
                  model="deep.admin_product_save.tar"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="nicotine">
                <FormLabel>
                  Nicotine (mg)
                </FormLabel>
                <Errors
                  className="errors"
                  model="deep.admin_product_save.nicotine"
                  show={{touched: true}}
                />
                <Control.text
                  component={FormControl}
                  model="deep.admin_product_save.nicotine"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="flavour">
                <FormLabel>
                  Flavour
                </FormLabel>
                <Errors
                  className="errors"
                  model="deep.admin_product_save.flavour"
                  show={{touched: true}}
                />
                <Control.text
                  component={FormControl}
                  model="deep.admin_product_save.flavour"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={{span: 2, offset: 10}}>
              <ArrowButton
                arrow={false}
                className="float-end"
                disabled={!this.props.formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.admin_product_save,
  formValid: state.deep.forms.admin_product_save.$form.valid,
  brands: state.brands.brands,
  category_id: state.deep.admin_product_save.category_id,
  productLoading: state.products.fetching && !state.products.fetched,
  groups: state.groupSelector.groups || [],
  exceptionPostcodes: state.groupSelector.postcodes || []
});

export default connect(mapStateToProps)(NewProduct);
